module.exports = __webpack_public_path__ + "img/news.a80b1eaf.svg";